export default __webpack_public_path__ + "static/media/anuj dixit.7a68ba46.jpg";